/* eslint-disable import/no-extraneous-dependencies */

import { GridColDef } from '@mui/x-data-grid';
import { BrowseView, browseViewColumnAction } from '@pro4-erp/core-web';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAuditorVisitRepReviewForMe } from '../api/getAuditorVisitRepReviewForMe';
import { AuditVisitRepReview } from '../types';
import { StatusChip } from '@/common';

const BrowsePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: GridColDef<AuditVisitRepReview>[] = [
    {
      ...browseViewColumnAction({
        field: 'actions',
        headerName: t('Open', { defaultValue: 'Open' }),
        icon: {
          element: <EditIcon />,
          color: 'primary',
        },
        onClick: ({ params }) => navigate(`/audit-visit-rep-review/${params.id}`),
      }),
      display: 'flex',
    },
    {
      field: 'clientName',
      display: 'flex',
      headerName: t('Client', { defaultValue: 'Client' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'visituId',
      display: 'flex',
      headerName: t('Visit uId', { defaultValue: 'Visit uId' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'reviewer',
      display: 'flex',
      headerName: t('Reviewer', { defaultValue: 'Reviewer' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'status',
      display: 'flex',
      headerName: t('Status', { defaultValue: 'Status' }).toString(),
      disableColumnMenu: true,
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        if (params.row.status) {
          return (
            <StatusChip
              codeId={params.row.status.codeId}
              name={params.row.status.name || ''}
              color={params.row.status.color}
            />
          );
        }
        return <>N/A</>;
      },
    },
  ];

  return (
    <BrowseView
      title={
        <BrowseView.Title>
          {t('Auditor visit report review', { defaultValue: 'Auditor visit report review' })}
        </BrowseView.Title>
      }
      browserViewContainerSx={{
        height: '100vh',
      }}
      columns={columns}
      fetchData={getAuditorVisitRepReviewForMe}
      toolbar={<BrowseView.Toolbar showSearch showDensityBtn />}
    />
  );
};

export default BrowsePage;
